// Default homepage content.
// The live site loads the final configuration from /api/site-config.
// Backend values can override these defaults.

export const DEFAULT_SITE_CONFIG = {
  announcementBar: {
    enabled: true,
    message:
      "Complimentary shipping on orders above ₹999  ·  Easy 7-day returns",
  },

  offerTicker: {
    enabled: true,
    autoplayMs: 4500,

    offers: [
      {
        icon: "sparkles",
        text: "Flat 10% Off on First Order",
      },
      {
        icon: "truck",
        text: "Free Shipping Above ₹999",
      },
      {
        icon: "tag",
        text: "Spring Sale — Up to 30% Off",
      },
      {
        icon: "ticket",
        text: "Use Code: SPRING10",
      },
    ],
  },

  hero: {
    overline: "The Spring Edit — 2026",

    titleLines: [
      "Where Elegance",
      "Meets Everyday",
    ],

    image:
      "https://images.pexels.com/photos/32443160/pexels-photo-32443160.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1800",

    ctaPrimary: {
      label: "Shop New Arrivals",
      href: "/new-arrivals",
    },

    ctaSecondary: {
      label: "Explore Dresses",
      href: "/dresses",
    },
  },

  collectionsSection: {
    enabled: true,
    overline: "Curated Three Ways",
    title: "Our Collections",

    items: [
      {
        handle: "dresses",
        title: "Dresses",
        subtitle: "Silhouettes that move with you",

        image:
          "https://images.unsplash.com/photo-1612336307429-8a898d10e223?crop=entropy&cs=srgb&fm=jpg&w=1600&h=1000&fit=crop",

        size: "large",
        visible: true,
        order: 1,
      },

      {
        handle: "new-arrivals",
        title: "New Arrivals",
        subtitle: "This week, freshly landed",

        image:
          "https://images.unsplash.com/photo-1638265499174-62c2cb29137a?crop=entropy&cs=srgb&fm=jpg&w=900&h=1000&fit=crop",

        size: "small",
        visible: true,
        order: 2,
      },

      {
        handle: "sale",
        title: "Sale",
        subtitle: "Considered pieces, gently priced",

        image:
          "https://images.unsplash.com/photo-1520026582657-4daf5bb60adb?crop=entropy&cs=srgb&fm=jpg&w=900&h=1000&fit=crop",

        size: "small",
        visible: true,
        order: 3,
      },
    ],
  },

  handPicked: {
    enabled: true,
    overline: "Handpicked",
    title: "Featured Pieces",

    productHandles: [
      "ivory-silk-slip-dress",
      "burgundy-wrap-midi",
      "beige-linen-shirt-dress",
      "warm-white-maxi",
    ],
  },

  // Our Story image is intentionally blank here.
  // The backend /api/site-config supplies:
  // /assets/about-us.png
  aboutPreview: {
    enabled: true,

    overline: "Our Story",

    title:
      "Considered clothing, made to be worn — not saved for later.",

    body:
      "Vastra West is an editorial line of western wear designed for the woman who reaches for the same three pieces on repeat. We make those three pieces — quietly, in small runs, from natural fabrics.",

    image: "",
  },

  footer: {
    newsletterOverline: "The Letter",

    newsletterHeadline:
      "Slow fashion, thoughtfully written.",

    newsletterCopy:
      "Editorials, new arrivals, and the occasional private sale — delivered fortnightly, never oftener.",
  },
};